import { Directive, forwardRef, Attribute } from "@angular/core";
import { Validator, AbstractControl, NG_VALIDATORS } from "@angular/forms";

export class RakazPasswordValidator implements Validator {
  public static readonly passwordValidationRegex =
    /(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,}/;
  constructor() {}

  public static testPasswordValidity(password: string) {
    return RakazPasswordValidator.passwordValidationRegex.test(password);
  }

  public validate(control: AbstractControl): { [key: string]: any } {
    if (
      control.value &&
      !RakazPasswordValidator.testPasswordValidity(control.value)
    ) {
      return {
        tooWeakPassword: true,
      };
    }

    return null;
  }
}



// WEBPACK FOOTER //
// ./src/app/_directives/rakaz-password.validator.ts